<container-padrao>

    <card title="Filtros">
        <filtros-dashboard (filtroChange)="changeFiltros($event)"></filtros-dashboard>
    </card>

    <div class="card-container row mt-3" *ngIf="!loading">
        <div class="col-lg-3 col-md-4 col-sm-6 mt-2">
            <div class="status-card iniciadas" (click)="onClickCardQuantidade('iniciadas')">
                <h2>Iniciadas</h2>
                <p>{{iniciadas}}</p>
            </div>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-6 mt-2">
            <div class="status-card concluidas" (click)="onClickCardQuantidade('concluidas')">
                <h2>Concluídas</h2>
                <p>{{concluidas}}</p>
            </div>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-6 mt-2">
            <div class="status-card nao-iniciadas" (click)="onClickCardQuantidade('nao-iniciadas')">
                <h2>Não iniciadas</h2>
                <p>{{naoIniciadas}}</p>
            </div>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-6 mt-2">
            <div class="status-card total" (click)="onClickCardQuantidade('total')">
                <h2>Total</h2>
                <p>{{total}}</p>
            </div>
        </div>
    </div>

    <div class="card-container row mt-3" *ngIf="loading">
        <div class="col-lg-3 col-md-4 col-sm-6 mt-2">
            <div class="skeleton-card iniciadas"></div>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-6 mt-2">
            <div class="skeleton-card concluidas"></div>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-6 mt-2">
            <div class="skeleton-card nao-iniciadas"></div>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-6 mt-2">
            <div class="skeleton-card total"></div>
        </div>
    </div>

    <div class="mt-5" *ngIf="showLoaderLicencas">
        <loader-page [show]="showLoaderLicencas"></loader-page>
    </div>

    <div class="mt-5" *ngIf="showTabelaLicencas" [ngClass]="{'d-none': showLoaderLicencas}">
        <tabela-listagem #listagemLicencas [colunas]="licencasResource"
            [actions]="actions"
            [service]="licencasFiltradasService"></tabela-listagem>
    </div>

</container-padrao>